import { Key, GeotabSensor } from "../../../../../../models";
import { EditSensorActions } from "../../flux";
import { Command1 } from "../../../../../../Command";

export class SetVehicleCommand implements Command1<Key>
{
    private readonly editActions = new EditSensorActions();
    constructor(private loadGeotabSensorsCmd: Command1<Key>, private setGeotabSensorCmd: Command1<GeotabSensor>)
    {        
    }

    execute = (vehicleId: Key): void => {
        this.editActions.setVehicle(vehicleId);
        this.setGeotabSensorCmd.execute(null);
        this.editActions.setGeotabSensorsItems([]);
        
        if(vehicleId != null) {
            this.loadGeotabSensorsCmd.execute(vehicleId);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/commands/Vehicle/SetVehicleCommand.ts